// extracted by mini-css-extract-plugin
module.exports = {"bottomBackground":"BottomBackground_bottomBackground__xDru-","inner":"BottomBackground_inner__gMwxI"};